
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/muse/register",
      function () {
        return require("private-next-pages/muse/register/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/muse/register"])
      });
    }
  